import {
  RESET_SKILLS,
  RESET_SKILL,
  RESET_ERROR,
  GET_SKILLS,
  SET_SKILLS,
  API_ERROR,
  CREATE_SKILL,
  CREATE_SKILL_SUCCESS,
  GET_SKILL,
  SET_SKILL,
  EDIT_SKILL,
  EDIT_SKILL_SUCCESS,
  DELETE_SKILL,
  DELETE_SKILL_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorSkill: false,
  loadingSkill: false,
  dataSkill: null,
  successSkill: false,
};

const Skill = (state = initialState, action) => {
  switch (action.type) {
    case RESET_SKILLS:
      state = {
        ...state,
        errorSkill: false,
        loadingSkill: false,
        loadingSkillDelete: false,
        successSkill: false,
        dataSkill: null,
        dataSkillDelete: null,
      };
      break;
    case RESET_SKILL:
      state = {
        ...state,
        errorSkill: false,
        loadingSkill: false,
        successSkill: false,
        dataSkillGetSet: null,
        dataSkillEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorSkill: false,
        loadingSkill: false,
        loadingSkillEditCreate: false,
        loadingSkillActivate: false,
        successSkill: false,
      };
      break;
    case GET_SKILLS:
      state = {
        ...state,
        errorSkill: false,
        loadingSkill: true,
        dataSkill: null,
      };
      break;
    case SET_SKILLS:
      state = {
        ...state,
        errorSkill: false,
        loadingSkill: false,
        dataSkill: action.payload,
      };
      break;
    case CREATE_SKILL:
      state = {
        ...state,
        errorSkill: false,
        loadingSkillEditCreate: true,
        dataSkillEditCreate: action.payload,
        successSkill: false,
      };
      break;
    case CREATE_SKILL_SUCCESS:
      state = {
        ...state,
        errorSkill: false,
        loadingSkillEditCreate: false,
        dataSkillEditCreate: action.payload,
        successSkill: true,
      };
      break;
    case GET_SKILL:
      state = {
        ...state,
        errorSkill: false,
        loadingSkill: true,
        dataSkillGetSet: null,
      };
      break;
    case SET_SKILL:
      state = {
        ...state,
        errorSkill: false,
        loadingSkill: false,
        dataSkillGetSet: action.payload,
      };
      break;
    case EDIT_SKILL:
      state = {
        ...state,
        errorSkill: false,
        loadingSkillEditCreate: true,
        dataSkillEditCreate: action.payload,
        successSkill: false,
      };
      break;
    case EDIT_SKILL_SUCCESS:
      state = {
        ...state,
        errorSkill: false,
        loadingSkillEditCreate: false,
        dataSkillEditCreate: action.payload,
        successSkill: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorSkill: action.payload,
        loadingSkill: false,
        loadingSkillEditCreate: false,
        loadingSkillDelete: false,
        successSkill: false,
      };
      break;
    case DELETE_SKILL:
      state = {
        ...state,
        errorSkill: false,
        loadingSkillDelete: true,
        dataSkillDelete: action.payload,
        successSkill: false,
      };
      break;
    case DELETE_SKILL_SUCCESS:
      state = {
        ...state,
        errorSkill: false,
        loadingSkillDelete: false,
        dataSkillDelete: action.payload,
        successSkill: true,
      };
      break;
    default:
      // state = { ...state, errorSkill: false, loadingSkill: false };
      break;
  }
  return state;
};

export default Skill;
